<div class="modal-detail">
    <div class="modal-header">
        <h2>Incomplete Reports</h2>
        <span class="dismiss" (click)="closeModal()"><i class="far fa-times-circle"></i></span>
    </div>
    <div class="modal-body">
        @if (canShowReportLimit) {
            <div class="reportLimit">
                <span class="label">Overdue report limit:</span>
                <span class="edit">
                    <span class="down" (click)="decreaseLimit()"><i class="fa-regular fa-square-minus"></i></span>
                    <span class="value" [class.changed]="originalLimit != overdueReportLimit">{{overdueReportLimit}}</span>
                    <span class="up" (click)="increaseLimit()"><i class="fa-regular fa-square-plus"></i></span>
                    <button class="save" [disabled]="originalLimit == overdueReportLimit" (click)="saveChangedLimit()">
                        @if (!isProcessing) {
                            <i class="fa-regular fa-floppy-disk"></i>
                        }
                        @if (isProcessing) {
                            <i class="fa-regular fa-hourglass"></i>
                        }
                    </button>
                </span>
            </div>
        }
        @if (applicants.length > 0) {
            <div class="table-container">
                <table class="table table-striped table-fixed">
                    <tbody>
                        @for (a of applicants; track a) {
                            <tr class="applicant" (click)="openApplicant(a)">
                                <td>
                                    @if (a.status > 0) {
                                        <span container="body" ngbPopover="{{a.statusInfo}}" popoverClass="slot-popover"
                                            triggers="mouseenter:mouseleave" popoverTitle="Note"><i class="warning fa-solid fa-circle-exclamation"></i></span>
                                    }
                                    {{a.name}}
                                </td>
                                @if (showInterviewer) {
                                    <td class="interviewer">{{a.interviewerName}}</td>
                                }
                                <td class="state">{{a.userState}}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        <div class="buttons">
            <button type="button" class="btn btn-danger btn-wide" (click)="closeModal()">Close</button>
        </div>
    </div>
</div>